module.exports = __webpack_public_path__ + "assets/img/00034.f5bb54a2.png";